import { makeStyles } from "@material-ui/core/styles";

const COMPASS_SIZE = 95;
const COMPASS_BOTTOM = 60;
const COMPASS_RIGHT = 20;
const LEGEND_HEIGHT = 30;
// Match the compass footprint so the legend sits exactly centered under it
// while keeping the same clearance from the right panel.
const PILL_WIDTH = COMPASS_SIZE;

export default makeStyles(() => ({
  root: {
    pointerEvents: "none",
    position: "absolute",
    bottom: COMPASS_BOTTOM - LEGEND_HEIGHT,
    right: COMPASS_RIGHT,
    width: PILL_WIDTH,
    height: LEGEND_HEIGHT,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 15,
    backgroundColor: "rgba(47, 53, 60, 0.8)",
    zIndex: 1,
    "@media print": {
      display: "none"
    },
    "@media screen and (max-width: 700px), screen and (max-height: 420px)": {
      display: "none"
    }
  },
  label: {
    fontFamily: "'Roboto', sans-serif",
    fontSize: 14,
    fontWeight: "lighter",
    lineHeight: "16px",
    color: "#FFFFFF",
    whiteSpace: "nowrap",
    textAlign: "center"
  },
  scaleBar: {
    borderLeft: "1px solid #FFFFFF",
    borderRight: "1px solid #FFFFFF",
    borderBottom: "1px solid #FFFFFF",
    height: 6,
    marginTop: 2
  }
}));
